import { type RefObject, useEffect, useRef } from 'react';

import { StreamFlowPacer } from '@atlassian/editor-ai-common/api/stream-flow-pacer';

import { isAdfStreamingEnabled } from '../adf-streaming';

export function createStreamFlowPacer(): StreamFlowPacer {
	return new StreamFlowPacer({
		tickMs: 41, // 24 fps to avoid issues with RAF and scroll listeners
		initialCharsPerTick: 8,
		maxCharsPerTick: 1000,
		backlogRampThreshold: 100,
		ramp: { initialDelaySec: 6, stepDelaySec: 3, flushDelaySec: 0.5, growthFactor: 1.5 },
	});
}

export function useStreamFlowPacerRef(
	isInDocumentStreamingEnabled?: boolean,
): RefObject<StreamFlowPacer> {
	const streamFlowPacerRef = useRef<StreamFlowPacer | null>(null);

	if (!streamFlowPacerRef.current && (isAdfStreamingEnabled() || isInDocumentStreamingEnabled)) {
		streamFlowPacerRef.current = createStreamFlowPacer();
	}

	// destroy the stream flow pacer when unmounted
	useEffect(() => {
		streamFlowPacerRef.current?.destroy();
	}, []);

	return streamFlowPacerRef;
}
